export const MICROSOFT_CLIENT_STATE='c21fe67c-98c4-4b9c-bb4a-8a73b40ed7a8'